// extracted by mini-css-extract-plugin
var _1 = "NewsboardPostProfileHeaderContent-moduleNewsboardPostProfileHeaderContent__MYMml";
var _2 = "NewsboardPostProfileHeaderContent-moduleactions__oIvM4";
var _3 = "NewsboardPostProfileHeaderContent-moduleeditable__rrFjb";
var _4 = "NewsboardPostProfileHeaderContent-modulemessage__yFMp7";
var _5 = "NewsboardPostProfileHeaderContent-modulemessageContent__XCwgd";
export { _1 as "NewsboardPostProfileHeaderContent", _2 as "actions", _3 as "editable", _4 as "message", _5 as "messageContent" }
